module.exports = __webpack_public_path__ + "static/media/pic1.1f1f1d84.jpg";